export default __webpack_public_path__ + "static/media/book2.e328d010.png";